export let NotEntitledJustification;
(function (NotEntitledJustification) {
  NotEntitledJustification["MISSING_PERMISSION"] = "MISSING_PERMISSION";
  NotEntitledJustification["MISSING_FEATURE"] = "MISSING_FEATURE";
  NotEntitledJustification["BUNDLE_EXPIRED"] = "BUNDLE_EXPIRED";
})(NotEntitledJustification || (NotEntitledJustification = {}));